import { BrowserRouter } from "react-router-dom";
import "./App.css";

import AppRoutes from "./routes/AppRoutes";
// import { IPublicClientApplication } from "@azure/msal-browser";
// import { MsalProvider } from "@azure/msal-react";

const App = () => {
  return (
    // <MsalProvider instance={pca}>
      <BrowserRouter>
        <AppRoutes />
      </BrowserRouter>
    // </MsalProvider>
  );
};

export default App;
